/* blocks */
import IndividualCaseStudyPageHero from './components/CaseStudyHero/IndividualCaseStudyPageHero'
import CaseStudyMetaDetails from './components/CaseStudyMetaDetails/CaseStudyMetaDetails'
import CaseStudyContent from './components/CaseStudyContent/CaseStudyContent'
import CaseStudyCta from './components/CaseStudyCta/CaseStudyCta'

/* utils */
import { IndividualCaseStudyPageAttributes } from '@/utils/queries/individual-case-studies-page'
import { stripHtml } from './components/customerStories'

interface Props {
  data: IndividualCaseStudyPageAttributes
}

function CaseStudyIndividualPages({ data }: Props) {
  const tag = [
    data.segment?.trim().replace(/_/g, ' '),
    data.categoryLabel?.trim()
  ]
    .filter(Boolean)
    .join(' · ')

  const nextStory = data.moreCaseStudies.data[0]?.attributes

  const metadata = data.caseStudyMetadata.map(item => ({
    title: stripHtml(item.title),
    description: stripHtml(item.description)
  }))
  // The design's meta band ends with the customer champion; it isn't part of
  // the CMS metadata blocks, so surface it from the testimonial author.
  const champion = data.testimonial?.authorName?.trim()
  if (champion && !metadata.some(item => /champion/i.test(item.title))) {
    metadata.push({
      title: 'Champion',
      description: [champion, data.testimonial.authorDesignation?.trim()]
        .filter(Boolean)
        .join(', ')
    })
  }

  return (
    <div className="overflow-x-clip">
      <IndividualCaseStudyPageHero
        title={data.heroTitle}
        description={data.heroDescription}
        company={data.testimonial?.authorCompany?.trim()}
        tag={tag}
        featuredImage={data.featuredImage.data?.attributes}
        customerLogo={
          data.customerLogoWhite?.data?.attributes ??
          data.customerLogo.data?.attributes
        }
        stats={data.statisticsList.map(item => ({
          // CMS stat blocks carry inline colors authored for the old dark
          // hero — render them as plain text on the new white card.
          title: stripHtml(item.title),
          description: stripHtml(item.description)
        }))}
      />

      {metadata.length > 0 ? <CaseStudyMetaDetails metadata={metadata} /> : null}

      {data.content ? (
        <CaseStudyContent
          content={data.content}
          testimonial={data.testimonial}
          videoUrl={data.testimonialVideoUrl}
          nextStory={
            nextStory
              ? { slug: nextStory.slug, title: nextStory.heroTitle }
              : undefined
          }
        />
      ) : null}

      {data.footerCta.title ? <CaseStudyCta footerCta={data.footerCta} /> : null}
    </div>
  )
}

export default CaseStudyIndividualPages
